module.exports = __webpack_public_path__ + "img/hosting3.b288786e.png";